import thunk from 'redux-thunk';
import playSessionLock from './playSessionLock';

export default [thunk, playSessionLock];
